/**
 * useFeedback — TanStack Query hooks for feedback endpoints.
 *
 * @spec SPEC:ENGINEERING:PLATFORM:FEEDBACK
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { CreateFeedback, FeedbackRow, ListResponse } from '@/types'

export function useSubmitFeedback() {
  return useMutation<
    { id: string; createdAt: string },
    Error,
    CreateFeedback
  >({
    mutationFn: (body) => api.post<{ id: string; createdAt: string }>('/feedback', body),
  })
}

export function useAdminFeedback(page: number, pageSize = 20) {
  return useQuery<ListResponse<FeedbackRow>>({
    queryKey: ['admin', 'feedback', { page, pageSize }],
    queryFn: () =>
      api.get<ListResponse<FeedbackRow>>(
        `/admin/feedback?page=${page}&pageSize=${pageSize}`,
      ),
    staleTime: 30_000,
  })
}
